// Sets up stereograph Dialog box

// imports
import React from 'react' // react library
import { withStyles } from '@material-ui/core/styles' // styles for material UI
import Dialog from '@material-ui/core/Dialog' // dialog from material UI
import AppBar from '@material-ui/core/AppBar' // App bar from material UI
import Toolbar from '@material-ui/core/Toolbar'// tool bar from material UI
import IconButton from '@material-ui/core/IconButton' // Icon button for close button
import CloseIcon from '@material-ui/icons/Close' // close icon for button
import Slide from '@material-ui/core/Slide' // slider for speed adjustment
import {Stereospeedslider} from './Stereograph.js' //import stereograph functionality

// set styles
const styles = {
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  imgContainer: {
    position: 'relative',
    flex: 1,
    padding: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  img: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
}

// set open and close transitions
function Transition(props) {
  return <Slide direction="up" {...props} />
}

// main dialog class component
export class StereoDialog extends React.Component {
  state = {
    open: false,
  }

  handleClickOpen = () => {
    this.setState({ open: true })
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { classes } = this.props
    return (
      <Dialog
        fullScreen
        open={!!this.props.img && !!this.props.img2}
        onClose={this.props.onClose}
        TransitionComponent={Transition}
        id = "previewWindow"
      >
        <AppBar id="banner">
          <Toolbar>
            <IconButton
              onClick={this.props.onClose}
              aria-label="Close"
              id="close-button2"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div>
            {/*
            add in stereograph instead of image
            <img src={this.props.img} alt="Cropped" className="previewImage" />
            */}
          <Stereospeedslider name="Speed Dialog" image1 ={this.props.img} image2={this.props.img2} />
        </div>
      </Dialog>
    )
  }
}


// export the dialog for use in other components
export default withStyles(styles)(StereoDialog)
